import { h } from "@stencil/core";
import { createStore } from "@stencil/store";

export const { state: stepState, onChange } = createStore({
    step: 1
});

export const StepNavigation = ({ t, multipleSteps }) =>
    multipleSteps ? (
        <div class="ux-u-margin-top-40 ux-u-margin-bottom-40">
            <ux-steps>
                <ux-steps-item
                    onClick={() => (stepState.step = 1)}
                    number={1}
                    current={stepState.step === 1}
                    done={stepState.step > 1}
                >
                    {t("headline.caseDetails")}
                </ux-steps-item>
                <ux-steps-item onClick={() => (stepState.step = 2)} number={2} current={stepState.step === 2}>
                    {t("headline.contactData")}
                </ux-steps-item>
            </ux-steps>
        </div>
    ) : null;

export const StepNext = ({ t, multipleSteps, onCancel }) =>
    multipleSteps ? (
        <div class="ux-row">
            <div class="ux-col-12 ux-u-margin-bottom-20">
                <div class="ux-text-normal ux-text-normal--light-gray">
                    <p>{t("validation.requiredFieldsExplanation")}</p>
                </div>
            </div>
            <div class="ux-col-12">
                <ux-button variant="primary" onClick={() => (stepState.step = 2)}>
                    {t("button.next")}
                </ux-button>

                <ux-button type="button" onClick={() => onCancel()}>
                    {t("button.cancel")}
                </ux-button>
            </div>
        </div>
    ) : null;

export const StepBack = ({ t, multipleSteps }) =>
    multipleSteps ? (
        <ux-button type="button" onClick={() => (stepState.step = 1)}>
            {t("button.back")}
        </ux-button>
    ) : null;
